import { nanoid } from 'nanoid';
import { MEDIA_FILE_AUDIO as QuestionType } from '../../../../../poll';
import { config } from './MediaFileAudio.config';

export function generateQuestion(_answers: unknown[], overrides: Partial<QuestionType['data']> = {}): QuestionType {
  return {
    id: nanoid(10),
    data: {
      type: config.name,
      text: '',
      logicRules: [],
      audioSrc: '',
      percentToUnlockMedia: 0,
      ...overrides,
    },
  };
}
